import httpClient from '../../httpClient';

/**
 * invite token을  서버에 넘겨주는 api
 * @param {string} inviteToken - inviteToken
 * @returns {Promise}
 */
function passOnInviteToken(inviteToken) {
  return httpClient({
    url: `/user/org-name/${inviteToken}`,
    method: 'post',
  });
}

export default passOnInviteToken;
